export const portfolio = [
    {
        nome: 'Erick Lisboa Design',
        img: '../../../assets/img/portfolio/022-erick-designer.png',
        url: 'https://lisboaerk.design/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Colégio IENEC',
        img: '../../../assets/img/portfolio/021-colegioienec.png',
        url: 'http://www.colegioienec.com',
        location: 'Mogi das Cruzes - SP/Brazil',
    },
    {
        nome: 'Inteli.Fi - Empresa de Wi-fi Ads',
        img: '../../../assets/img/portfolio/020-intelifi.png',
        url: 'http://www.inteli.fi/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Norsrsken Eventos',
        img: '../../../assets/img/portfolio/019-norrksken.png',
        url: 'https://norrskeneventos.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Agência Galharufa - Casting Model Agency - New Version',
        img: '../../../assets/img/portfolio/018-galharufa.png',
        url: 'http://www.agenciagalharufa.com.br',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Agência Galharufa - Casting Model Agency',
        img: '../../../assets/img/portfolio/017-galharufa.png',
        url: 'http://www.agenciagalharufa.com.br',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Cliffe Cleaning - Cleaner company',
        img: '../../../assets/img/portfolio/016-cliffecleaning.png',
        url: 'https://www.cliffecleaning.com/',
        location: 'Brisbane/QLD/Australia',
    },
    {
        nome: 'Ação Covid 19 - Covid19 research webpage',
        img: '../../../assets/img/portfolio/015-acaocovid.png',
        url: 'http://www.acaocovid19.org',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Pão de Açúcar - Supermarket e-commerce webpage',
        img: '../../../assets/img/portfolio/014-paodeacucar.png',
        url: 'http://www.paodeacucar.com',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'MeSeems - Digital Research Web App',
        img: '../../../assets/img/portfolio/013-meseems.png',
        url: 'http://www.meseems.com',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'MindMiners - Digital Research Company',
        img: '../../../assets/img/portfolio/012-mindminers.png',
        url: 'http://www.mindminers.com',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Kademi',
        img: '../../../assets/img/portfolio/001-kademi.png',
        url: 'https://www.kademi.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Noturnall - Brazilian Metal band',
        img: '../../../assets/img/portfolio/002-noturnall.png',
        url: '#',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Leo Zac Photography',
        img: '../../../assets/img/portfolio/003-leozac.png',
        url: '#',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Rds Codes Startup',
        img: '../../../assets/img/portfolio/004-rdscodes.png',
        url: 'https://www.rdsdigital.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Rds Digital Startup',
        img: '../../../assets/img/portfolio/005-rdsdigital.png',
        url: 'https://www.rdsdigital.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'ViSi Arq - Architecture Studio',
        img: '../../../assets/img/portfolio/007-visiarq.png',
        url: '#',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Edson Yassuo - Videographer',
        img: '../../../assets/img/portfolio/008-edsonyassuo.png',
        url: '#',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Seiki Alimentos - Food supplier',
        img: '../../../assets/img/portfolio/009-seiki.png',
        url: 'http://seikialimentos.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Alpha Institute - Integrated Medicine Web Site',
        img: '../../../assets/img/portfolio/010-alpha.png',
        url: 'http://www.institutoalpha.com.br/',
        location: 'Sao Paulo/Brazil',
    },
    {
        nome: 'Focco Câmbio - Currency Exchange',
        img: '../../../assets/img/portfolio/011-focco.png',
        url: 'https://foccoturismo.com.br/',
        location: 'Sao Paulo/Brazil',
    },
];
